import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["workflow"]
  static values = { url: String }

  refresh() {
    Turbo.visit(`${this.urlValue}?workflow_id=${this.workflowTarget.value}`, { frame: "expected_columns" })
  }
}
